import React from "react";
import { useLenis } from "@/components/landing/useLenis";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { TrustStrip } from "@/components/landing/TrustStrip";
import { Problem } from "@/components/landing/Problem";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { LiveDemo } from "@/components/landing/LiveDemo";
import { Features } from "@/components/landing/Features";
import { Stats } from "@/components/landing/Stats";
import { Comparison } from "@/components/landing/Comparison";
import { Pricing } from "@/components/landing/Pricing";
import { AdRevenue } from "@/components/landing/AdRevenue";
import { Roadmap } from "@/components/landing/Roadmap";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { CursorTrail } from "@/components/landing/CursorTrail";

export default function Landing() {
    useLenis();
    return (
        <div className="paper-grain min-h-screen">
            <CursorTrail/>
            <Nav/>
            <main>
                <Hero/>
                <TrustStrip/>
                <Problem/>
                <HowItWorks/>
                <LiveDemo/>
                <Features/>
                <Stats/>
                <Comparison/>
                <Pricing/>
                <AdRevenue/>
                <Roadmap/>
                <FAQ/>
                <FinalCTA/>
            </main>
            <Footer/>
        </div>
    );
}
